function isElementInViewport(el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  var rect = el.getBoundingClientRect();
  var threshold = jQuery ? jQuery(el).height() / 2 : 100; // detect element a bit earlier

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + threshold && /*or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) + threshold /*or $(window).width() */
  );
}